import _ from 'lodash';

// function parseItemOptions(category, item) {
//   if ((item.options?.length ?? 0) > 0) {
//     return item.options;
//   }

//   if ((category.options?.length ?? 0) > 0) {
//     return category.options;
//   }

//   return null;
// }

// function parseItemRequiredOptions(category, item) {
//   const count =
//     (item?.options?.length == null
//       ? category?.options?.length
//       : item?.options?.length) ?? 0;

//   if (count === 0) {
//     return {
//       min: 0,
//       max: 0,
//     };
//   }

//   const result = {
//     min:
//       item.min_required_options == null
//         ? category.min_required_options
//         : item.min_required_options,
//     max:
//       item.max_required_options == null
//         ? category.max_required_options
//         : item.max_required_options,
//   };

//   result.min = result.min == null ? 1 : result.min;
//   result.max = result.max == null ? 1 : result.max;

//   return result;
// }

function parseItemDescription(item, group) {
  return `${adjustPunctuation(item?.description)} ${adjustPunctuation(
    group?.description
  )}`.trim();
}

function adjustPunctuation(text) {
  if (!_.isString(text)) return '';

  let result = text.trim();
  const regex = /(.+)([.?!;])/g;
  const match = regex.exec(result);

  if (match == null && !_.isEmpty(result)) {
    result = `${result}.`;
  }

  return result;
}

export {
  parseItemDescription,
  // parseItemRequiredOptions,
  // parseItemOptions,
};
